module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_30.967ebf0a.pdf";